import i18n from '../lang/i18n'; // Internationalization，因为this.$t无法使用，所以特的导入。
/*
经讨论，selectOptions.js中一致存放数组，如要进行回显操作(即根据值取label)，
则调用tool.arrayConvertToObject 或 this.arrayConvertToObject方法进行转换
 */
export const selectOption = {
  // 类型  人民币、比特币系列、以太坊、以太坊代币
  direction: {
    '1': i18n.t('selectOption.direction.1'),
    '2': i18n.t('selectOption.direction.2'),
  },
  buysSellOptions: [
    { value: '1', label: '买入' },
    { value: '2', label: '卖出' }],
  receiptDisburseOptions: [
    { value: '1', label: '收入' },
    { value: '2', label: '支出' }],
  operateTypeOptions: [
    { label: '全部', value: '' },
    { label: '买入', value: '1' },
    { label: '卖出', value: '2' }],
  exchangeStatusOptions: [
    { label: '全部', value: '' },
    { label: '未成交', value: '0' },
    { label: '已成交', value: '1' },
    { label: '已撤销', value: '2' },
    { label: '部分成交', value: '3' }],
  // 个人资产净价值
  grossAssetArr: [
    { label: '0-20,000', value: 1 },
    { label: '20,001-50,000', value: 2 },
    { label: '50,001-100,000', value: 3 },
    { label: '100,001-250,000', value: 4 },
    { label: '250,001-500,000', value: 5 },
    { label: '500,001-1,000,000', value: 6 },
    { label: '1,000,001-3,000,000', value: 7 },
    { label: '3,000,001-5,000,000', value: 8 },
    { label: '>5,000,000', value: 9 }],
  // 预期投资水平
  expectedInvestmentArr: [
    { label: '0-5,000', value: 1 },
    { label: '5,001-10,000', value: 2 },
    { label: '10,001-20,000', value: 3 },
    { label: '20,001-50,000', value: 4 },
    { label: '50,001-100,000', value: 5 },
    { label: '>100,000', value: 6 },
    { label: ' ', value: 7 }],
  // yes or no
  yesOrNoArr: [
    { label: 'YES', value: '1' },
    { label: 'NO', value: '2' }],
  // 有 或 无
  hasOrNot: [
    { label: '无', value: '0' },
    { label: '有', value: '1' }],
  // 是 或 否
  isOrNot: [
    { label: '是', value: 'true' },
    { label: '否', value: 'false' }],
  // 性别
  genderArr: [
    /*    { label: '请选择您的性别', value: '' }, */
    { label: '男(male)', value: '1' },
    { label: '女(famale)', value: '2' },
    { label: '未知(unknown)', value: '0' }],
  // c2c买入订单状态
  tradingBuyStatusArr: [
    { value: '0', label: '打款中' }, // 待付款
    { value: '1', label: '支付成功' }, // 充值成功
    { value: '2', label: '已取消' },
    // 已上传回执待确认
    { value: '3', label: '等待确认' }],
  // c2c卖出订单状态
  tradingSellStatusArr: [
    { value: '0', label: '正在处理' }, // 待处理
    { value: '1', label: '打款成功' }, // 成功
    { value: '2', label: '已取消' },
    // 已上传回执待确认
    { value: '3', label: '等待确认' }],
  // c2c商家充值订单状态(买入订单状态)
  merchantRechargeStatusOptions: [
    { value: '0', label: '未完成' },
    { value: '3', label: '等待确认' },
    { value: '1', label: '已完成' },
    { value: '2', label: '已取消' }],
  // c2c商家提现订单状态(卖出订单状态)
  merchantWithdrawalStatusOptions: [
    { value: '0', label: '未完成' },
    { value: '3', label: '等待确认' },
    { value: '1', label: '已完成' },
    { value: '2', label: '已取消' }],
  // 提现状态
  withdrawStatusOptions: [
    { value: '0', label: '审核中' },
    { value: '1', label: '成功' },
    { value: '2', label: '拒绝' },
    { value: '3', label: '已撤销' },
    { value: '4', label: '审核通过' },
    { value: '5', label: '打币中' }],
  // 来源
  clientType: [
    { value: 'WEB', label: '电脑版网页' },
    { value: 'H5', label: '手机版网页' },
    { value: 'APP', label: 'APP' }],
  // 交易类型
  transType: [
    { value: '1', label: '买入' },
    { value: '2', label: '卖出' },
    { value: '3', label: '买/卖' }],
};
